import { twMerge } from '@faceup/ui'
import { Typography } from '@faceup/ui-base'

type PageTitleProps = {
  children: React.ReactNode
  description?: React.ReactNode
  className?: string
}

const PageTitle = ({ children, description, className }: PageTitleProps) => (
  <div className={twMerge('text-center w-full', className)}>
    <Typography.Title data-test='page-title' className='mb-5'>
      {children}
    </Typography.Title>
    {description && <span data-test='page-description'>{description}</span>}
  </div>
)

export default PageTitle
